// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    PostInspectionVocHomePageQueryVocOverViewBody,
    BaseResponseResult12,
} from '../../types';

/**
 * queryVocOverView
 *
 * @export
 * @tags inspection-voc-home-page-controller
 * @link [POST] /inspectionVocHomePage/queryVocOverView
 */
export function postInspectionVocHomePageQueryVocOverView(
    data: PostInspectionVocHomePageQueryVocOverViewBody
): Promise<BaseResponseResult12>;
export function postInspectionVocHomePageQueryVocOverView(
    data: PostInspectionVocHomePageQueryVocOverViewBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseResult12>;
export function postInspectionVocHomePageQueryVocOverView(
    data: PostInspectionVocHomePageQueryVocOverViewBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseResult12> {
    return request<PostInspectionVocHomePageQueryVocOverViewBody, never, never>(
        '/inspectionVocHomePage/queryVocOverView',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postInspectionVocHomePageQueryVocOverView',
        }
    );
}

export const meta = [
    {
        tags: ['inspection-voc-home-page-controller'],
        path: '/inspectionVocHomePage/queryVocOverView',
        method: 'post',
    },
];
